import { useSelector } from 'react-redux';

import { ISiteSettings } from '@sravni/types/lib/sitesettings';

import { getSiteSettings } from '../store/selectors/sitesettings';

export function useSiteSettings(): ISiteSettings {
  return useSelector(getSiteSettings);
}
